import Lenis from 'lenis';

const lenis = new Lenis({
  autoRaf: true,
});

$(window).on('disable-scroll', () => {
  $('body').addClass('is-open') && lenis.stop();
});
$(window).on('enable-scroll', () => {
  if (!window.keepScrollDisabled) {
    $('body').removeClass('is-open') && lenis.start();
  }
});
